import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { EVENT_TRACK, EVENT_TRACK_SUCCESS, EVENT_TRACK_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* EventTrack({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { supportTicketId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/support-tickets/${supportTicketId}/activity-events`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      // cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: EVENT_TRACK_SUCCESS,
        payload: response?.data,
      });
    } else {
      // cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: EVENT_TRACK_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: EVENT_TRACK_ERROR, payload: error });
  }
}

export function* watchEventTrack() {
  yield takeEvery(EVENT_TRACK, EventTrack);
}

function* EventTrackSaga() {
  yield all([fork(watchEventTrack)]);
}

export default EventTrackSaga;
